import axios from 'axios'
import qs from 'qs'

export const status = params => { return axios.get(`/dealer/account/status`, { params: params }) }
export const login = params => { return axios.post(`/dealer/account/login`, params) }
export const logout = params => { return axios.post(`/dealer/account/logout`, params) }
export const password = params => { return axios.post(`/dealer/account/password`, params) }

export const listpage = params => { return axios.get(`/user`, { params: params }) }
export const save = params => { return params.id ? axios.put(`/user`, params) : axios.post(`/user`, params) }
export const all = params => { return axios.get(`/user/all`, { params: params }) }
export const remove = params => { return axios.delete(`/user/${params.id}`, { params: params }) }
export const get = params => { return axios.get(`/user/` + params.id, { params: params }) }



// WEBPACK FOOTER //
// ./src/services/api/dealer/user/index.js